import List from "rc-virtual-list"

import { Flex } from "@/atoms"
import { useLinkDrawerTooltip } from "@/hooks/useLinkDrawerTooltip"
import { InformationPopover } from "@/molecules/InformationPopover"
import { getApplicationKey } from "./helpers"

import styles from "./ImpactCell.module.scss"

import type { ImpactPopoverProps } from "."

export const ImpactPopover = (props: ImpactPopoverProps) => {
  const { title, items, footer, renderItem, children, onRowClick } = props

  const { open, openDrawer } = useLinkDrawerTooltip({
    onRowClick
  })

  const itemHeight = 57
  const maxItems = 5
  const maxHeight = Math.min(items?.length || 0, maxItems) * itemHeight

  return (
    <InformationPopover.Popover
      destroyOnHidden
      open={open}
      placement="auto"
      classNamePopover={styles.popover}
      content={
        <InformationPopover.CommonTemplate
          title={title}
          classes={{
            title: styles.applicationTitle,
            content: styles.applicationContent,
            footer: styles.applicationFooter
          }}
          footer={footer}
        >
          <List
            data={items}
            height={maxHeight}
            itemHeight={itemHeight}
            itemKey={(item: any) => getApplicationKey(item) as string}
          >
            {(item) => renderItem(item, openDrawer)}
          </List>
        </InformationPopover.CommonTemplate>
      }
    >
      <Flex gap={8} align="center">
        {children}
      </Flex>
    </InformationPopover.Popover>
  )
}
